import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWAuth } from "../../../utils/api-service";
import { IB_CUST_RATETYPE_LIST } from "../../../constants/constant";


export const fetchCustomRates = createAsyncThunk(
  "customRates/fetchCustomRates",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getDataWAuth(IB_CUST_RATETYPE_LIST, params);
      console.log("Custom Rates Response from reducer:", response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const customRatesSlice = createSlice({
  name: "customRates",
  initialState: {
    customRatesData: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearCustomRates: (state) => {
      state.customRatesData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch Custom Rates
    builder
      .addCase(fetchCustomRates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCustomRates.fulfilled, (state, action) => {
        state.customRatesData = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchCustomRates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCustomRates } = customRatesSlice.actions;
export default customRatesSlice.reducer;
